<button [type]="buttonType" class="btn" [ngClass]="classList" [disabled]="loading || disabled" (click)="onClick()">
  <span class="buttonInlineIcon" *ngIf="inlineIcon" [inlineSVG]="inlineIcon"></span>
  <span class="buttonLabel">{{ label | translate }}</span><span *ngIf="label && sublabel">&nbsp;{{sublabel}}</span> <span *ngIf="loading && label && !inlineIcon">&nbsp;</span><fa-icon [icon]="faCircleNotchIcon" [spin]="true" *ngIf="loading"></fa-icon>
  <fa-icon [icon]="icon" *ngIf="icon && !loading"></fa-icon>
</button>
